import * as React from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { alpha, useTheme } from '@mui/material/styles';

import { iconButtonBaseSx } from './megaMenuOverlay.constants';

type OverlayIconButtonProps = {
	ariaLabel: string;
	onClick: () => void;
	children: React.ReactNode;
	disabled?: boolean;
	sx?: SxProps<Theme>;
};

const OverlayIconButton = React.forwardRef<HTMLButtonElement, OverlayIconButtonProps>(
	({ ariaLabel, onClick, children, disabled, sx }, ref) => {
		const white = useTheme().palette.common.white;

		return (
			<Box
				ref={ref}
				component="button"
				type="button"
				aria-label={ariaLabel}
				disabled={disabled}
				onClick={onClick}
				sx={{
					...iconButtonBaseSx,
					color: white,
					'&:focusVisible': {
						outline: `2px solid ${alpha(white, 0.6)}`,
						outlineOffset: 4
					},
					...(sx as Record<string, unknown>)
				}}
			>
				{children}
			</Box>
		);
	}
);

OverlayIconButton.displayName = 'OverlayIconButton';

export default OverlayIconButton;
